import React, { useEffect, useState } from 'react';
import { LAND_IMAGES } from '../data/brandAssets';

export const HERO_SLIDES = [
  { key: 'ackerland', image: LAND_IMAGES.ackerland, word: 'Ihr Acker', label: 'Ackerland', to: '/ackerland-verkaufen' },
  { key: 'wald', image: LAND_IMAGES.wald, word: 'Ihr Wald', label: 'Wald', to: '/wald-verkaufen' },
  { key: 'gruenland', image: LAND_IMAGES.gruenland, word: 'Ihr Grünland', label: 'Grünland', to: '/gruenland-verkaufen' },
  { key: 'bauernhof', image: LAND_IMAGES.bauernhof, word: 'Ihr Hof', label: 'Bauernhof & Hofstelle', to: '/bauernhoefe-verkaufen' },
  { key: 'sonderkulturen', image: LAND_IMAGES.sonderkulturen, word: 'Ihre Sonderfläche', label: 'Weinberg, Hopfen, Jagd & Co.', to: '/sonderkulturen-verkaufen' }
];

export const useHeroSlide = (intervalMs = 6000) => {
  const [index, setIndex] = useState(0);
  const [tick, setTick] = useState(0);
  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;
    const t = setInterval(() => setIndex((i) => (i + 1) % HERO_SLIDES.length), intervalMs);
    return () => clearInterval(t);
  }, [intervalMs, tick]);
  const select = (i) => { setIndex(i); setTick((n) => n + 1); };
  return [index, select];
};

export const HERO_LCP = { src: '/images/hero/acker-1264.webp', srcSet: '/images/hero/acker-900.webp 900w, /images/hero/acker-1264.webp 1264w', sizes: '100vw' };

export const HeroSlides = ({ index }) => {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setReady(true), 2500);
    return () => clearTimeout(t);
  }, []);
  return (
    <div className="hv-hero-media absolute inset-0" aria-hidden="true" data-testid="hero-slides">
      {HERO_SLIDES.map((s, i) => {
        if (i > 0 && !ready) return null;
        const img = i === 0 ? HERO_LCP : { src: s.image };
        return (
          <img key={s.key} {...img} alt="" fetchPriority={i === 0 ? 'high' : 'low'} decoding={i === 0 ? 'sync' : 'async'}
            className={`hv-slide absolute inset-0 w-full h-full object-cover object-[60%_55%] ${i === index ? 'is-active' : ''}`} data-testid={`hero-slide-${s.key}`} />
        );
      })}
      <div className="hv-hero-fade absolute inset-0" />
    </div>
  );
};
